<template>
  <CRow>
    <CCol xs="12" sm="12" md="12" lg="4" xl="3">
      <CCard>
        <CCardHeader class="d-flex justify-content-between">
          <b><i class="fas fa-calendar"></i>&nbsp;Fecha</b>
        </CCardHeader>
        <CCardBody>
          <CRow>
            <CCol xl="12" md="12" sm="12" xs="12">
              <label>Encargado</label>
            </CCol>
            <CCol xl="12" md="12" sm="12" xs="12">
              <v-select v-model="barber" :reduce="(name) => name.id" :options="barbers"
                placeholder="Seleccione varias opciones..." label="label" :close-on-select="false" multiple
                @input="validateDates" />
            </CCol>
            <CCol xs="12" sm="6" md="6" lg="12" xxl="12">
              <CInput label="Desde" type="date" aria-label="shift_date" @input="validateDates" size="sm" id="init"
                v-model="filter_init" :max="today" />
            </CCol>
            <CCol xs="12" sm="6" md="6" lg="12" xxl="12">
              <CInput label="Hasta" type="date" aria-label="shift_date" @input="validateDates" id="end" size="sm"
                v-model="filter_end" :max="today" />
            </CCol>
          </CRow>
        </CCardBody>
      </CCard>
      <CCard class="mt-3" v-if="barber && barber.length > 0">
        <CCardHeader class="d-flex justify-content-between">
          <b><i class="fas fa-file"></i>&nbsp;Resumen</b>
        </CCardHeader>
        <CCardBody>
          <p><b>Días laborados:</b> {{ totalDias }}</p>
          <p><b>Pago Diario:</b> S/ 75.00 </p>
          <p><b>Sueldo:</b> S/ {{ sueldoBase.toFixed(2) }}</p>
          <p><b>Pago por hora:</b> S/ {{ precioHora.toFixed(2) }}</p>
          <hr>
          <p><b>Total tardanza:</b> {{ formatTimeFromMinutes(totalMinTardanza) }}</p>
          <p><b>Total horas extra:</b> {{ formatTimeFromMinutes(totalMinExtras) }}</p>
          <p><b>Diferencia:</b> {{ formatTimeFromMinutes(diferenciaMin) }}</p>
          <hr>
          <p><b>Descuento por tardanza:</b> S/ {{ descuentoTardanza.toFixed(2) }}</p>
          <p><b>Pago por horas extra:</b> S/ {{ pagoHorasExtra.toFixed(2) }}</p>
          <hr>
          <h4>Total a pagar: S/ {{ totalPagar.toFixed(2) }}</h4>
        </CCardBody>
      </CCard>
      <CCard class="mt-3" v-else>
        <CCardBody class="text-center text-muted">
          <i class="fas fa-user fa-2x mb-2"></i>
          <p class="mb-0">Seleccione un encargado para ver el resumen.</p>
        </CCardBody>
      </CCard>
    </CCol>
    <CCol xs="12" sm="12" md="12" lg="8" xl="9">
      <CTableWrapper :items="data" :fields="fields" hover :striped="true" :border="true" small fixed caption="Reporte"
        icon="fas fa-coins" @mtdBack="mtdBack" :size="'md'" :withActions="'2%'" :actions="false" :myButtons="myButtons">
      </CTableWrapper>
    </CCol>
  </CRow>
</template>

<script>
const fields = [
  { key: "index", label: "N°", _style: "width:5%;" },
  { key: "barbers", label: "Encargados", _style: "width:5%;" },
  { key: "date", label: "Fecha", _style: "width:5%;" },
  { key: "hours_init", label: "Hora de llegada", _style: "width:5%;" },
  { key: "tardanza", label: "Tardanza", _style: "width:5%;" },
  { key: "hours_end", label: "Hora de Salida", _style: "width:5%;" },
  { key: "horas_extra", label: "Horas extra", _style: "width:5%;" },
];
import CTableWrapper from "../shared/datatable/Table.vue";
import { mapActions } from "vuex";
import moment from "moment";
export default {
  components: {
    CTableWrapper,
  },
  data() {
    return {
      prefix: "report",
      fields,
      data: [],
      barber: [],
      barbers: [],
      filter_init: null,
      filter_end: null,
      today: moment().format("YYYY-MM-DD"),
      pagoDiario: 75,
      horasDia: 10.5,
      //buttons
      myButtons: [
        {
          class: "btn-sm",
          color: "success",
          tooltip: "Editar",
          action: "mtdAddDescription",
          icon: "fas fa-edit",
        },
      ],
    }
  },
  computed: {
    precioHora() {
      return this.pagoDiario / this.horasDia;
    },
    totalDias() {
      if (!this.barber || this.barber.length === 0) return 0;
      return this.data.length;
    },
    totalMinTardanza() {
      return this.data.reduce((acc, item) => acc + (item._tardanza_min || 0), 0);
    },
    totalMinExtras() {
      return this.data.reduce((acc, item) => acc + (item._extras_min || 0), 0);
    },
    diferenciaMin() {
      return Math.abs(this.totalMinTardanza - this.totalMinExtras);
    },
    sueldoBase() {
      return this.totalDias * this.pagoDiario;
    },
    descuentoTardanza() {
      return (this.totalMinTardanza / 60) * this.precioHora;
    },
    pagoHorasExtra() {
      return (this.totalMinExtras / 60) * this.precioHora;
    },
    totalPagar() {
      return this.sueldoBase - this.descuentoTardanza + this.pagoHorasExtra;
    }
  },
  created() {
    moment.locale("es");
    this.filter_init = this.today;
    this.filter_end = this.today;
    this.mtd_data();
  },
  methods: {
    ...mapActions(["get", "post"]),
    mtdBack: function () {
      this.$emit("mtdBack");
    },
    formatTimeFromMinutes(minutes) {
      const totalMins = Math.floor(minutes || 0);
      const hours = Math.floor(totalMins / 60);
      const mins = totalMins % 60;
      return [
        hours.toString().padStart(2, '0'),
        mins.toString().padStart(2, '0'),
      ].join(':');
    },
    validateDates() {
      if (this.filter_init > this.today) {
        this.filter_init = this.today;
      }
      if (this.filter_end > this.today) {
        this.filter_end = this.today;
      }
      if (this.filter_end < this.filter_init) {
        this.filter_init = this.filter_end;
      }
      if (this.filter_init > this.filter_end) {
        this.filter_end = this.filter_init;
      }
      this.mtd_data();
    },
    mtd_data: function () {
      this.post({
        url: this.$store.getters.get__url + "/" + this.prefix + "/byAsistenciaRank",
        token: this.$store.getters.get__token,
        params: {
          init: this.filter_init,
          end: this.filter_end,
          campu_id: this.$store.getters.get_campu.id,
          company_id: this.$store.getters.get_company.id,
          barbers: this.barber
        },
      })
        .then((response) => {
          if (response.statusCode == 200) {
            this.barbers = response.data.barbers;
            this.data = response.data.data.map(item => ({
              ...item,
              _tardanza_min: item.tardanza || 0,
              _extras_min: item.horas_extra || 0,
              tardanza: this.formatTimeFromMinutes(item.tardanza || 0),
              horas_extra: this.formatTimeFromMinutes(item.horas_extra || 0),
            }));
          }
        })
        .catch((errors) => {
          Swal.fire({
            title: errors,
            icon: "error",
          });
        });
    },
  }
}
</script>